import React from 'react'
import { RouteProps } from 'react-router'
import { Route, Redirect } from 'react-router-dom'

import { authStore } from 'adminConsole/store'
import { Path } from 'adminConsole'

export const ProtectedRoute: React.FC<RouteProps> = props => (
  authStore.isLogin ? <Route {...props} /> : <Redirect to={Path.Login} />
)